import {
  FormInput,
  SubmitButton,
  AuthLink,
  WelcomeMessage,
} from "@/components/ui";
import { motion } from "framer-motion";
import logo from "@/assets/img/icons/logo.svg";

interface RegistrationStep1Props {
  onSubmit: () => void;
  onLoginClick: () => void;
  name: string;
  birthDate: string;
  nameError: string | null;
  birthDateError: string | null;
  setName: (name: string) => void;
  setBirthDate: (birthDate: string) => void;
}

export const RegisterStep1: React.FC<RegistrationStep1Props> = ({
  onSubmit,
  onLoginClick,
  name,
  birthDate,
  nameError,
  birthDateError,
  setName,
  setBirthDate,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 100 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="h-full"
    >
      <div className="flex flex-col items-center mb-6">
        <img src={logo} alt="logo" className="w-50 h-50 mb-2 mt-4" />
      </div>

      <WelcomeMessage
        text="Для составления Зодиакального гороскопа, астрологам важно знать ваше имя и дату рождения:"
        textAlign="left"
        className="rounded-lg"
        showOverlay={false}
      />

      <div className="flex flex-col gap-6 w-full">
        <FormInput
          id="name"
          label="Имя"
          type="text"
          value={name}
          onChange={setName}
          error={nameError}
        />
        <FormInput
          id="birthDate"
          label="Дата рождения"
          type="date"
          value={birthDate}
          onChange={setBirthDate}
          max={new Date().toISOString().split("T")[0]}
          error={birthDateError}
        />
        <SubmitButton text="Продолжить" onClick={onSubmit} />
      </div>
      <div className="flex flex-col items-center flex-1 px-4 pb-6 w-full max-w-[430px] mx-auto mt-2">
        <AuthLink
          question="У вас уже есть аккаунт?"
          linkText="Войти"
          onClick={onLoginClick}
        />
      </div>
    </motion.div>
  );
};
export default RegisterStep1;
